

import templateOrderListPage from '@/app-template/lib/pages/OrderListPage.vue';

export default {
  name: "OrderListPage",
  components: { templateOrderListPage },
};
